import { RoleEnum } from '../model/enum/role.enum';

export function canAccess(userRole: RoleEnum, canAccessTo?: RoleEnum): boolean {
  return !canAccessTo || userRole === canAccessTo;
}
